import { Dialog, DialogActions, DialogContent, DialogTitle, Tab, Tabs } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import imageCompression from 'browser-image-compression';
import { FileUploader } from "react-drag-drop-files";
import { PDFDocument } from "pdf-lib";
import { FaFilePdf } from "react-icons/fa6";
import { ColorRing } from 'react-loader-spinner';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, ConvertToCharacterCaseTwo, DropDownData, FetchAutoCompleteData, FileUploadChild, convertToAlphaNum, convertToNumber, convertToAlphabet, convertTwoDecimalsOnValue, getDateAndTime, handleDateChange, sanitizeInput } from '../CommonComponents/CustomHooks';
import { base64ToBlob } from '../CommonComponents/EnvConfig';
import FinalView from '../CommonComponents/FinalView';
import { AutoCompleteBoxNew, AutoCompleteBoxNumeric, DateBox, FormButton, InputBox, InputGroupBox, SelectInputBox } from '../CommonComponents/InputBox';
import PopupWithIcon from '../CommonComponents/Popups';
import { TrackStepper } from './Stepper';
import { GetSession, SetSession } from '../CommonComponents/cryptoUtils';

const SaleEntry = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const location = useLocation();
    let ProductCode = location?.pathname?.split('/')[2]?.replace(/%20/g, ' ') || '';
    const regex = /ASSET/i;
    let checkAsset = regex.test(ProductCode)
    const user = GetSession('cookies', 'user')
    const HeaderIDLocal = window.localStorage.getItem('HeaderID');
    const queryParams = new URLSearchParams(location.search);
    const [message, setMessage] = useState(false);
    const [openPaymentModal, setOpenPaymentModal] = useState(false);
    const [Response, setResponse] = useState({});
    const [ErrorResponse, setErrorResponse] = useState({});
    const [OTPValue, setOTPValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showAmount, setShowAmount] = useState(false)
    const [timer, setTimer] = useState(0)
    const [isDisabled, setIsDisabled] = useState(false)
    const [isChecked, setIsChecked] = useState(true);
    const [customerPaymentStatus, setCustomerPaymentStatus] = useState(false)
    const [PaymentResponse, setPaymentResponse] = useState({})
    const salesId = queryParams.get('SalesID');
    const check = queryParams.get('Action_Type');
    const Action_Type = GetSession('sessionstorage', "Action_Type")
    const [Progress, setProgress] = useState('20%');
    const [ProgressStage, setProgressStage] = useState('SALE');
    const [InvoiceNoofDays, setInvoiceNoofDays] = useState('')
    const [amountDetailsData, setAmountDetailsData] = useState({
        cost: '',
        product: '',
        assestProductName: '',
        isCustomerPayment: false
    });

    const [formData, setFormData] = useState({
        type: checkAsset ? "ASSET" : 'PHONESAFE',
        terms: isChecked,
        productCode: ProductCode,
        headerId: '',
        ModelId: '',
        businessPartner: '',
        sumInsured: '',
        title: '',
        firstName: '',
        lastName: '',
        gender: '',
        category: '',
        categoryName: '',
        manufacturer: '',
        manufacturerName: '',
        otherManufacturer: '',
        serialNo: '',
        invoiceNo: '',
        totalInvoiceValue: '',
        invoiceDate: getDateAndTime().date,
        noOfYears: checkAsset ? "" : "1",
        cost: '',
        currency: '',
        dealerName: '',
        bankReference: '',
        salesChannelDetail: '',
        salesChannelSecondDetail: '',
        dealerCode: '',
        delaerLocation: '',
        modelNo: '',
        modelName: '',
        otherModelNo: '',
        imei: '',
        purchaseDate: getDateAndTime().date,
        billingAddressLine1: '',
        billingAddressLine2: '',
        billingAddressLine3: '',
        billingTown: '',
        billingPostcode: '',
        billingState: '',
        telephoneNumber: '',
        emailAddress: '',
        mobilePhoneNumber: '',
        selectionType: 'PAYLATER',
        paymentType: '',
        commsDirectMail: '',
        commsEmail: '',
        commsFax: '',
        commsSms: '',
        commsTelemarket: '',
        paymentStatus: '',
        applicationStatus: '',
        remarks: '',
        isRemember: false,
        "manufacturerModelNo": "",
       // "manufacturerWarrantyPeriodYears": checkAsset ? "" : "1",
        "manufacturerWarrantyPeriodYears":  "",
        "imeiImage": "",
        "imeiExt": "",
        "imeiName": "",
        "invoiceImage": "",
        "invoiceExt": "",
        "invoiceName": "",
        "activationDate": "",
        "employeeID" : ''
    });
    const GetManufecturerType = DropDownData('GetManufacture', formData.category)
    const GetModel = DropDownData('GetModelViaManufacturer', formData.manufacturer)
    const GetAssetMaster = DropDownData('GetCategoryForSale', formData.productCode, user?.dealerCode)

    const getAmountDetails = async () => {
        const requestData = {
            productCode: formData.productCode,
            sumInsured: formData.sumInsured,
            category: formData.category,
            manufacturerWarrantyPeriodYears: formData.noOfYears
        };
        setIsLoading(true)
        let res = await ApiCall(`/api/DealerMaster/GetSaleEntryAmountDetail`, requestData)
        setIsLoading(false)
        if (res.status === "SUCCESS") {
            setShowAmount(true)
            setInvoiceNoofDays(res.invoiceNoofDays)
            setAmountDetailsData({
                cost: res.cost,
                product: res.product,
                assestProductName: res.assestProductName,
                isCustomerPayment: res.isCustomerPayment
            });
        }
        if (res.status === "ERROR") {
            setAmountDetailsData({
                cost: '',
                product: '',
                assestProductName: '',
                isCustomerPayment: res.isCustomerPayment
            })
            setShowAmount(false)
        }
        if (res.status === 'EXPIRED') {
            NotificationSound(res.status, res.message, res.focus, inputrefs);
        }
    }

    const getSalesDetails = async (value) => {
        const requestData = {
            HeaderID: value
        };
        await dispatch(setSubLoading(true))
        let res = await ApiCall(`/api/DealerMaster/GetSaleEntryDetail`, requestData)
        await dispatch(setSubLoading(false))
        if (res.status === "SUCCESS") {
            setFormData((pre) => ({
                ...pre, ...res
            }))
        } else {
            await NotificationSound(res.status, res.message, res.focus, inputrefs, handleClear)
        }
    }

    const handleClear = () => {
        setFormData({
            type: formData.type,
            productCode: ProductCode,
            headerId: '',
            businessPartner: '',
            sumInsured: '',
            title: '',
            firstName: '',
            lastName: '',
            gender: '',
            category: '',
            manufacturer: '',
            otherManufacturer: '',
            serialNo: '',
            invoiceNo: '',
            totalInvoiceValue: '',
            invoiceDate: getDateAndTime().date,
            noOfYears: checkAsset ? "" : "1",
            cost: '',
            currency: '',
            dealerName: '',
            bankReference: '',
            salesChannelDetail: '',
            salesChannelSecondDetail: '',
            dealerCode: '',
            delaerLocation: '',
            modelNo: '',
            otherModelNo: '',
            imei: '',
            purchaseDate: getDateAndTime().date,
            billingAddressLine1: '',
            billingAddressLine2: '',
            billingAddressLine3: '',
            billingTown: '',
            billingPostcode: '',
            billingState: '',
            telephoneNumber: '',
            emailAddress: '',
            mobilePhoneNumber: '',
            selectionType: 'PAYLATER',
            paymentType: '',
            commsDirectMail: '',
            commsEmail: '',
            commsFax: '',
            commsSms: '',
            commsTelemarket: '',
            paymentStatus: '',
            applicationStatus: '',
            remarks: '',
            manufacturerModelNo: "",
            manufacturerWarrantyPeriodYears: checkAsset ? "" : "1",
            "imeiImage": "",
            "imeiExt": "",
            "imeiName": "",
            "invoiceImage": "",
            "invoiceExt": "",
            "invoiceName": "",
            "activationDate": "",
            "employeeID" : ""
        });
        setProgressStage('SALE');
        setProgress('20%');
        setShowAmount(false)
        setCustomerPaymentStatus(false)
    }

    const OpenImage = (fileBase64, ext) => {
        if ((ext).toLowerCase() === 'pdf') {
            const blob = base64ToBlob(fileBase64, 'application/pdf');
            const url = URL.createObjectURL(blob);
            const pdfWindow = window.open(url, '_blank');
            if (!pdfWindow) {
                throw new Error("Please allow pop-ups for this site");
            }
            pdfWindow.document.title = "View PDF";
        } else {
            const blob = base64ToBlob(fileBase64, 'image/jpeg');
            const url = URL.createObjectURL(blob);
            const imageWindow = window.open(url, '_blank');
            if (!imageWindow) {
                throw new Error("Please allow pop-ups for this site");
            }
            imageWindow.document.title = "View Image";
        }
    }

    const handleTabChange = (event, newValue) => {
        setShowAmount(false)
        setFormData({
            ...formData, type: newValue,
            productCode: ProductCode,
            headerId: '',
            businessPartner: '',
            sumInsured: '',
            title: '',
            firstName: '',
            lastName: '',
            gender: '',
            category: '',
            manufacturer: '',
            otherManufacturer: '',
            serialNo: '',
            invoiceNo: '',
            totalInvoiceValue: '',
            invoiceDate: getDateAndTime().date,
            noOfYears: '',
            cost: '',
            currency: '',
            dealerName: '',
            bankReference: '',
            salesChannelDetail: '',
            salesChannelSecondDetail: '',
            dealerCode: '',
            delaerLocation: '',
            modelNo: '',
            otherModelNo: '',
            imei: '',
            purchaseDate: getDateAndTime().date,
            billingAddressLine1: '',
            billingAddressLine2: '',
            billingAddressLine3: '',
            billingTown: '',
            billingPostcode: '',
            billingState: '',
            telephoneNumber: '',
            emailAddress: '',
            mobilePhoneNumber: '',
            selectionType: 'PAYLATER',
            paymentType: '',
            commsDirectMail: '',
            commsEmail: '',
            commsFax: '',
            commsSms: '',
            commsTelemarket: '',
            paymentStatus: '',
            applicationStatus: '',
            remarks: '',
            manufacturerModelNo: "",
            manufacturerWarrantyPeriodYears: "",
            "imeiImage": "",
            "imeiExt": "",
            "imeiName": "",
            "invoiceImage": "",
            "invoiceExt": "",
            "invoiceName": "",
            "activationDate": "",
            "employeeID": ""
        })
    };

    useEffect(() => {
        let interval;

        if (timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
        } else if (timer === 0 && isDisabled) {
            setIsDisabled(false);
            //setOpenPaymentModal(false)
        }

        return () => clearInterval(interval);
    }, [timer, isDisabled]);

    const handleSendOtp = async () => {
        try {
            await dispatch(setSubLoading(true))
            await (setOTPValue(''))
            await setErrorResponse({})
            let data = await ApiCall(`/api/Login/SendOTPToMobileNo`, { ...formData, onlinePaymentID: formData.headerId, "Type": "PaymentOTP" });
            await dispatch(setSubLoading(false))
            setResponse(data)
            if (data.status === 'SUCCESS') {
                await setOpenPaymentModal(true)
                await setTimer(30);
                await setIsDisabled(true);
            } else if (data.status === 'ERROR') {
                await setOpenPaymentModal(false)
                await NotificationSound(data.status, data.message, data.focus, inputrefs);
            }
        } catch (error) {
            console.error('Error sending OTP:', error);
        } finally {
        }
    };

    const handleSubmit = async (value) => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/DealerMaster/InsertUpdateSaleEntry`, { ...formData, ProcessType: ProgressStage, MemberShipCost: amountDetailsData.cost })
        await dispatch(setSubLoading(false))
        await setFormData((pre) => ({
            ...pre, headerId: data.headerID, MemberShipCost: amountDetailsData.cost
        }))
        await setOpenPaymentModal(false)
        if (data.status === 'SUCCESS') {
            await window.localStorage.setItem('HeaderID', data.headerID);
            if (value === 'DEALER') {
                await handlePayment(data.headerID)
            } else if (value === 'SALE') {
                if (amountDetailsData.cost === '' && Number(amountDetailsData.cost) <= 0) {
                    await NotificationSound('ERROR', 'Membership Amount could not be Zero [0]!')
                    return
                }
                await setProgressStage('CONFIRM')
                await setProgress('50%')
            } else if (value === 'C') {
                await NotificationSound(data.status, data.message, data.focus, inputrefs);
                await setCustomerPaymentStatus(true)

            } else if (value === 'P') {
                await NotificationSound(data.status, data.message, data.focus, inputrefs);
            } else if (value === 'E') {
                handleSendOtp()
            }
        }
        else if (data.status === 'ERROR' || data.status === 'EXPIRED') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs);
        }
    };

    const handlePayment = async (headerID) => {
        const requestData = {
            "HeaderID": headerID,
            otp: OTPValue || ''
        };
        try {
            await dispatch(setSubLoading(true))
            const data = await ApiCall('/api/SalesEntryAPI/MakePayment', requestData)
            if (data.status === "SUCCESS") {
                await setCustomerPaymentStatus(true)
                await setOpenPaymentModal(false)
                if (data.payByToken) {
                    await initiateCheckout(data.token);
                    await window.localStorage.setItem('OnlinePaymentID', '');
                } else {
                    await window.localStorage.setItem('OnlinePaymentID', data.orderId);
                    await window.open(data.paymentURL, '_blank');
                    await dispatch(setSubLoading(false))
                }
            } else {
                await setErrorResponse(data)
                await dispatch(setSubLoading(false))
                await setCustomerPaymentStatus(false)
                await setOpenPaymentModal(true)
            }
        } catch (error) {
            await dispatch(setSubLoading(false))
            console.error('Error in payment process:', error);
        }
    };

    const initiateCheckout = async (token) => {
        await dispatch(setSubLoading(false))
        const initData = {
            token: token,
            waProfileData: '',
            key: JSON.stringify({
                curCredentials: {
                    pkcsSalt: '',
                    rsaSalt: '',
                },
            }),
        };
        if (window.bfl && window.bfl.initiate) {
            window.bfl.initiate(initData);
        } else {
            console.error('Bajaj Finserv Checkout JS is not available');
        }
    };

    const handleCheckResponse = async (value) => {
        const requestData = {
            "OnlinePaymentID": value ? value : '',
            "headerID": HeaderIDLocal
        }
        try {
            if (!customerPaymentStatus) {
                await dispatch(setSubLoading(true))
            }
            const data = await ApiCall('/api/SalesEntryAPI/CheckPaymentStatus', requestData)
            if (data.status === 'SUCCESS') {
                if (data.policyStatus === 'SUCCESS') {
                    await setCustomerPaymentStatus(false)
                    SetSession('sessionstorage', "Action_Type", '8081');
                    setProgressStage('FINAL')
                    setMessage(data.policyMessage)
                    setProgress('100%')
                }
                else if (data.paymentStatus === 'SUCCESS' || data.policyStatus === 'ERROR') {
                    if (data?.paymentDataResponse?.statusCode === '00') {
                        //if (!customerPaymentStatus) {
                        //    await handleSubmitRef(HeaderIDLocal, data?.paymentDataResponse?.orderId)
                        //} else {
                            SetSession('sessionstorage', "Action_Type", '8081');
                            await dispatch(setSubLoading(false))
                            await setPaymentResponse({ errorDesc: 'Payment completed successfully!', status: 'SUCCESS' })
                            await setProgressStage('PAYMENT')
                            await setProgress('80%')
                       // }
                        await dispatch(setSubLoading(false))
                    } else {
                        await dispatch(setSubLoading(false))
                        await setPaymentResponse({ errorDesc: 'Something went wrong please try after sometime.!', status: 'Failed' })
                        await setProgressStage('PAYMENT')
                        await setProgress('80%')
                        await setCustomerPaymentStatus(false)
                    }
                }
                else if (data.paymentStatus === 'SUCCESS' || data.policyStatus === 'PROCESSING') {
                    if (data?.paymentDataResponse?.statusCode === '00') {
                        //if (!customerPaymentStatus) {
                        //    await handleSubmitRef(HeaderIDLocal, data?.paymentDataResponse?.orderId)
                        //}  else{
                            SetSession('sessionstorage', "Action_Type", '8081');
                            await dispatch(setSubLoading(false))
                            await setPaymentResponse({ errorDesc: 'Payment completed successfully!', status: 'SUCCESS' })
                            await setProgressStage('PAYMENT')
                            await setProgress('80%')
                       //}
                        await dispatch(setSubLoading(false))
                    } else {
                        await dispatch(setSubLoading(false))
                        await setPaymentResponse({ errorDesc: 'Something went wrong please try after sometime.!', status: 'Failed' })
                        await setProgressStage('PAYMENT')
                        await setProgress('80%')
                        await setCustomerPaymentStatus(false)
                    }
                } else if (data.policyStatus === 'ERROR') {
                    await setCustomerPaymentStatus(false)
                }
            } else {
                await dispatch(setSubLoading(false))
                if (!customerPaymentStatus) {
                    await NotificationSound(data.status, data.message);
                }
            }
        } catch (error) {
            await dispatch(setSubLoading(false))
            console.error('Error in payment process:', error);
        }
    };

    //const handleSubmitRef = async (headerID, orderId) => {
    //    if (!isChecked) {
    //        await NotificationSound('ERROR', 'Please check our term & conditions !')
    //        return
    //    }
    //    await dispatch(setSubLoading(true))
    //    let data = await ApiCall(`/api/SalesEntryAPI/GeneratePolicyNo`, { HeaderID: HeaderIDLocal, OnlinePaymentID: orderId })
    //    await dispatch(setSubLoading(false))
    //    if (data.status === 'SUCCESS') {
    //        SetSession('sessionstorage', "Action_Type", '8081');
    //        setProgressStage('FINAL')
    //        setMessage(data.message)
    //        setProgress('100%')
    //    }
    //    else if (data.status === 'ERROR') {
    //        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    //    }
    //};

    const handleNext = () => {
        if (ProgressStage === 'SALE') {
            handleSubmit('SALE')
        } else if (ProgressStage === 'CONFIRM') {
            setProgress('80%')
        }
    };

    const handlePrev = () => {
        if (ProgressStage === 'CONFIRM') {
            setProgressStage('SALE');
            setProgress('20%');
        }
    };

    const tabData = [
        {
            tabName: 'Phone',
            tabKey: 'PHONESAFE'
        },
        {
            tabName: 'Asset',
            tabKey: 'ASSET'
        }
    ];

    useEffect(() => {
        document.title = 'Sale Entry'
        const handlePaymentUpdate = async (event) => {
            const paymentResponse = event?.detail?.response;
            await handleCheckResponse(event?.detail?.redirectParam?.param[2]?.orderId)
            if (paymentResponse.code === '00') {
            } else if (paymentResponse.code === '11') {
                await dispatch(setSubLoading(false))
                await setPaymentResponse(paymentResponse)
                await setProgressStage('PAYMENT')
                await setProgress('80%')
            }
        };
        /******** for Resolving ERROR of payment getway end ***********/
        let payButton = document.createElement("div");
        payButton.id = "paybutton";
        payButton.innerHTML = ".";
        payButton.addEventListener("click", function () {
            console.log("Payment initiated !");
        });
        document.body.appendChild(payButton)
        let newElement = document.createElement("div");
        newElement.id = "checkoutRefFailed";
        newElement.innerHTML = ".";
        document.body.appendChild(newElement);
        window.addEventListener('checkoutUpdate', handlePaymentUpdate);
        let a = document.getElementById("checkoutRefFailed")
        /******** for Resolving ERROR of payment getway end ***********/


        /******** for Resolving SUCCESS of payment getway end ***********/
        document.body.appendChild(payButton)
        let newElement1 = document.createElement("div");
        newElement1.id = "checkoutRefSuccess";
        newElement1.innerHTML = ".";
        document.body.appendChild(newElement1);
        window.addEventListener('checkoutUpdate', handlePaymentUpdate);
        let a1 = document.getElementById("checkoutRefFailed")
        /******** for Resolving SUCCESS of payment getway end ***********/
        return () => {
            window.removeEventListener('checkoutUpdate', handlePaymentUpdate);
        };
    }, []);

    const handlePaymentSelection = async (v) => {
        if (v === '') {
            NotificationSound('ERROR', 'Please select Selection Type.!')
        }
        else if (v === 'C' && !isChecked) {
            await NotificationSound('ERROR', 'Please check our term & conditions !')
            return
        }
        else if (v === 'E' && !isChecked) {
            await NotificationSound('ERROR', 'Please check our term & conditions !')
            return
        }
        else if (v === 'C') {
            handleSubmit(v)
        } else if (v === 'D') {
            handleSubmit(v)
        } else if (v === 'E') {
            handleSubmit(v)
        } else if (v === 'P') {
            handleSubmit(v)
        }
    };

    const handleRetryPayment = async () => {
        await setProgressStage('CONFIRM')
        await setProgress('50%')
    };

    useEffect(() => {
        if (check !== "1") {
            SetSession('sessionstorage', "Action_Type", '8081');
        }
    }, [Action_Type])

    useEffect(() => {
        if (salesId) {
            getSalesDetails(salesId)
        }
    }, [salesId]);

    useEffect(() => {
        const delay = setTimeout(() => {
            if (formData.productCode !== '' && formData.sumInsured !== '' && formData.category !== '' && formData.noOfYears !== '') {
                getAmountDetails();
            }
        }, 500);
        return () => clearTimeout(delay);
    }, [formData.productCode, formData.sumInsured, formData.category, formData.noOfYears]);

    useEffect(() => {
        setFormData({
            headerId: '',
            ModelId: '',
            businessPartner: '',
            sumInsured: '',
            title: '',
            firstName: '',
            lastName: '',
            gender: '',
            category: '',
            manufacturer: '',
            otherManufacturer: '',
            serialNo: '',
            invoiceNo: '',
            totalInvoiceValue: '',
            invoiceDate: getDateAndTime().date,
            noOfYears: checkAsset ? "" : "1",
            cost: '',
            currency: '',
            dealerName: '',
            bankReference: '',
            salesChannelDetail: '',
            salesChannelSecondDetail: '',
            dealerCode: '',
            delaerLocation: '',
            modelNo: '',
            otherModelNo: '',
            imei: '',
            purchaseDate: getDateAndTime().date,
            billingAddressLine1: '',
            billingAddressLine2: '',
            billingAddressLine3: '',
            billingTown: '',
            billingPostcode: '',
            billingState: '',
            telephoneNumber: '',
            emailAddress: '',
            mobilePhoneNumber: '',
            selectionType: 'PAYLATER',
            paymentType: '',
            commsDirectMail: '',
            commsEmail: '',
            commsFax: '',
            commsSms: '',
            commsTelemarket: '',
            paymentStatus: '',
            applicationStatus: '',
            remarks: '',
            isRemember: false,
            "manufacturerModelNo": "",
           // "manufacturerWarrantyPeriodYears": checkAsset ? "" : "1",
            "manufacturerWarrantyPeriodYears":  "" ,
            productCode: ProductCode,
            type: checkAsset ? "ASSET" : 'PHONESAFE',
            "imeiImage": "",
            "imeiExt": "",
            "imeiName": "",
            "invoiceImage": "",
            "invoiceExt": "",
            "invoiceName": "",
            "activationDate": "",
            "employeeID": ""
        });
        setProgressStage('SALE');
        setProgress('20%');
        setShowAmount(false);
        setCustomerPaymentStatus(false)
    }, [ProductCode]);

    const intervalRef = useRef(null);
    const timeoutRef = useRef(null);

    useEffect(() => {
        if (customerPaymentStatus) {
            const startPolling = () => {
                intervalRef.current = setInterval(() => {
                    handleCheckResponse();
                }, 5000);

                timeoutRef.current = setTimeout(() => {
                    clearInterval(intervalRef.current);
                }, 1800000);
            };

            startPolling();
        }

        return () => {
            clearInterval(intervalRef.current);
            clearTimeout(timeoutRef.current);
        };
    }, [customerPaymentStatus]);

    return (
        <>
            <div className='main-card card'>
                <div className=' row px-3'>
                    <div className='card-header pb-1' style={{ padding: "5px" }}>
                        <div className='col-md-12 px-1'>
                            <div className='row'>
                                <h6 className="m-0">  {'Sale'} </h6>
                                <div className='p-1' >
                                    <TrackStepper Progress={Progress} formData={formData} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {ProgressStage === 'SALE' ?
                    <>
                        <div className='main_cn_tab'>
                            <Tabs
                                sx={{ minHeight: '20px' }}
                                value={formData.type}
                                onChange={handleTabChange}
                                variant="scrollable"
                                scrollButtons={false}
                                aria-label="scrollable prevent tabs example"
                            >
                                {tabData?.filter(item => item.tabKey === (formData.type === 'PHONESAFE' ? 'PHONESAFE' : 'ASSET')).map((item, index) => (
                                    <Tab
                                        key={`tabs${index}`}
                                        label={item.tabName}
                                        value={item.tabKey}
                                    />

                                ))}
                            </Tabs>
                        </div>
                        <div className='row mx-0'>
                            <div className='col-sm-9 p-1' >
                                <div className='row mx-0 product mb-2 py-1 border-rounded' style={{ borderTop: '2px solid red', boxShadow: 'rgb(254 170 170 / 28%) 2px 2px 9px' }}>
                                    <div className=''>
                                        <h6 className='mb-2'>Product Details</h6>
                                    </div>
                                    <AutoCompleteBoxNew
                                        id="txtProductCode"
                                        placeholder="Product Code"
                                        label={'Product Code'}
                                        onfocusevent={true}
                                        disabled
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        required={true}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtCategory'].focus()
                                            }
                                        }}
                                        autocompleteType='GetProductMasterViaDealerType'
                                        contextKey={user?.dealerCode}
                                        contextKey2={formData.type}
                                        value={formData.productCode || ''}
                                    />
                                    <SelectInputBox
                                        id="txtCategory"
                                        value={formData.category}
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        label='Category'
                                        required={true}
                                        onChange={(e) => setFormData({
                                            ...formData, category: e.target.value, manufacturer: '', modelNo: '', imei: '', imeiImage: "",
                                            imeiExt: "",
                                            imeiName: "",
                                            manufacturerModelNo: '', serialNo: ''
                                        })}
                                        inputrefs={inputrefs}
                                        disabled={formData.paid}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                (checkAsset) ?
                                                    inputrefs.current['txtManufacturerWarrantyPeriodYears'].focus() :
                                                    inputrefs.current['txtManufacturer'].focus();
                                            }
                                        }}
                                    >
                                        <option value=''>--Please Select--</option>
                                        {GetAssetMaster?.data?.dataList?.map((item, index) =>
                                            <option key={item.name + index} value={item.code}>{item.name}</option>
                                        )}
                                    </SelectInputBox>
                                    {/*change this fields key to no of years*/}
                                    <SelectInputBox
                                        id="txtManufacturerWarrantyPeriodYears"
                                        label={formData.type === 'PHONESAFE' ? "Membership Period (Years)" : "Exended Warranty (Years)"}
                                        disabled={formData.paid || !checkAsset}
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        maxLength='2'
                                        required={true}
                                        value={formData.noOfYears}
                                       // onChange={(e) => setFormData({
                                       //     ...formData, manufacturerWarrantyPeriodYears: convertToNumber(e.target.value), imei: '', imeiImage: "",
                                       //     imeiExt: "",
                                       //     imeiName: "",
                                       // })}
                                        onChange={(e) => setFormData({
                                            ...formData, noOfYears: convertToNumber(e.target.value)
                                        })}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtManufacturer'].focus()
                                            }
                                        }}
                                    >
                                        <option key='1' value=''>--Please Select--</option>
                                        <option key='2' value='1'>1 </option>
                                        <option key='3' value='2'>2 </option>
                                        <option key='4' value='3'>3 </option>
                                    </SelectInputBox>
                                    <SelectInputBox
                                        id="txtManufacturer"
                                        value={formData.manufacturer}
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        label='Manufacturer'
                                        required={true}
                                        onChange={(e) => setFormData({ ...formData, manufacturer: e.target.value, otherManufacturer: "", modelNo: '', serialNo: '' })}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {

                                                (formData.type === 'ASSET' && formData.manufacturer === 'Other') ?
                                                    inputrefs.current['txtOtherManufacturer'].focus() :
                                                    formData.type === 'ASSET' ?
                                                        inputrefs.current['txtManufacturerModelNo'].focus() :
                                                        formData.manufacturer === 'Other' ?
                                                            inputrefs.current['txtOtherManufacturer'].focus() :
                                                            inputrefs.current['txtSerialNo'].focus()
                                            }
                                        }}
                                    >
                                        <option value=''>--Please Select--</option>
                                        {GetManufecturerType?.data?.dataList?.map((item, index) =>
                                            <option key={item.name + index} value={item.code}>{item.name}</option>
                                        )}
                                        <option value='Other'>Other</option>
                                    </SelectInputBox>
                                    {formData.manufacturer === 'Other' &&
                                        <InputBox
                                            id="txtOtherManufacturer"
                                            placeholder="Other Manufacturer"
                                            label='Other Manufacturer'
                                            divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                            maxLength='20'
                                            required={true}
                                            value={formData.otherManufacturer}
                                            onChange={(e) => setFormData({
                                                ...formData,
                                                otherManufacturer: sanitizeInput(e.target.value),
                                                imei: '',
                                                imeiImage: "",
                                                imeiExt: "",
                                                imeiName: "",
                                            })}
                                            inputrefs={inputrefs}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    formData.type === 'ASSET' ?
                                                        inputrefs.current['txtManufacturerModelNo'].focus() :
                                                        inputrefs.current['txtSerialNo'].focus()
                                                }
                                            }}
                                        />
                                    }
                                    {formData.type === 'ASSET' &&
                                        <>
                                            <InputBox
                                                id="txtManufacturerModelNo"
                                                placeholder="Manufacturer Model No"
                                                label='Manufacturer Model No'
                                                divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                                maxLength='20'
                                                required={true}
                                                value={formData.manufacturerModelNo}
                                            onChange={(e) => setFormData({ ...formData, manufacturerModelNo: sanitizeInput(e.target.value), modelNo: e.target.value, })}
                                                inputrefs={inputrefs}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputrefs.current['txtExendedManufacturerWarrantyPeriodYears'].focus()
                                                    }
                                                }}
                                        />
                                        {/*ADD this fields */}
                                            <SelectInputBox
                                            id="txtExendedManufacturerWarrantyPeriodYears"
                                                label={"Manufacture Warranty (Years)"}
                                                divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                                maxLength='2'
                                                required={true}
                                                value={formData.manufacturerWarrantyPeriodYears}
                                                onChange={(e) => setFormData({
                                                    ...formData, manufacturerWarrantyPeriodYears: convertToNumber(e.target.value), imei: '', imeiImage: "",
                                                    imeiExt: "",
                                                    imeiName: "",
                                                })}
                                                inputrefs={inputrefs}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputrefs.current['txtSerialNo'].focus()
                                                    }
                                                }}
                                            >
                                            <option key='' value=''>--Please Select--</option>
                                                <option key='2' value='1'>1 </option>
                                                <option key='3' value='2'>2 </option>
                                                <option key='4' value='3'>3 </option>
                                                <option key='5' value='4'>4 </option>
                                                <option key='6' value='5'>5 </option>
                                            </SelectInputBox>
                                        </>
                                    }
                                    <InputBox
                                        id="txtSerialNo"
                                        placeholder="Serial No"
                                        label='Serial No'
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        maxLength='100'
                                        required={formData.type !== "PHONESAFE" || GetManufecturerType?.data?.isSerialNoRequired}
                                        value={formData.serialNo}
                                        onChange={(e) => setFormData({ ...formData, serialNo: sanitizeInput(e.target.value) })}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtModelNo'].focus();
                                            }
                                        }}
                                    />

                                    <InputBox
                                        id="txtModelNo"
                                        placeholder="Model No"
                                        label='Model No'
                                        required={true}
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        maxLength='20'
                                        // value={formData.manufacturerModelNo}
                                        value={formData.modelNo}
                                        onChange={(e) => setFormData({ ...formData, modelNo: sanitizeInput(e.target.value), otherModelNo: '' })}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                formData.modelNo === 'Other' ?
                                                    inputrefs.current['txtOtherModel'].focus() :
                                                    GetManufecturerType?.data?.imeiRequired ?
                                                        inputrefs.current['txtIMEI'].focus() :
                                                        inputrefs.current['txtInvoiceNo'].focus();
                                            }
                                        }}
                                    />
                                    {/*<SelectInputBox*/}
                                    {/*    id="txtModelNo"*/}
                                    {/*    placeholder="Model No"*/}
                                    {/*    label='Model No'*/}
                                    {/*    required={true}*/}
                                    {/*    value={formData.modelNo}*/}
                                    {/*    divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"*/}
                                    {/*    onChange={(e) => setFormData({ ...formData, modelNo: e.target.value, otherModelNo: '' })}*/}
                                    {/*    inputrefs={inputrefs}*/}
                                    {/*    onKeyDown={(e) => {*/}
                                    {/*        if (e.key === 'Enter') {*/}
                                    {/*            formData.modelNo === 'Other' ?*/}
                                    {/*                inputrefs.current['txtOtherModel'].focus() :*/}
                                    {/*                GetManufecturerType?.data?.imeiRequired ?*/}
                                    {/*                    inputrefs.current['txtIMEI'].focus() :*/}
                                    {/*                    inputrefs.current['txtInvoiceNo'].focus();*/}
                                    {/*        }*/}
                                    {/*    }}*/}
                                    {/*>*/}
                                    {/*    <option value=''>--Please Select--</option>*/}
                                    {/*    {GetModel?.data?.dataList?.map((item, index) =>*/}
                                    {/*        <option key={item.name + index} value={item.code}>{item.name}</option>*/}
                                    {/*    )}*/}
                                    {/*    <option value='Other'>Other</option>*/}
                                    {/*</SelectInputBox>*/}


                                    {formData.modelNo === 'Other' &&
                                        <InputBox
                                            id="txtOtherModel"
                                            placeholder="Other Model"
                                            label='Other Model'
                                            maxLength='50'
                                            required={true}
                                            value={formData.otherModelNo}
                                            divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                            onChange={(e) => setFormData({ ...formData, otherModelNo: ConvertToCharacterCaseTwo(e.target.value) })}
                                            inputrefs={inputrefs}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    GetManufecturerType?.data?.imeiRequired ?
                                                        inputrefs.current['txtIMEI'].focus() :
                                                        inputrefs.current['txtInvoiceNo'].focus();
                                                }
                                            }}
                                        />
                                    }
                                    {GetManufecturerType?.data?.imeiRequired &&
                                        <>
                                            <InputBox
                                                id="txtIMEI"
                                                placeholder="IMEI"
                                                label='IMEI'
                                                maxLength='15'
                                                required={GetManufecturerType?.data?.imeiRequired}
                                                value={formData.imei}
                                                divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                                onChange={(e) => setFormData({
                                                    ...formData, imei: convertToNumber(e.target.value), imeiImage: "",
                                                    imeiExt: "",
                                                    imeiName: "",
                                                })}
                                                inputrefs={inputrefs}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputrefs.current['txtInvoiceNo'].focus()
                                                    }
                                                }}
                                            />
                                            <div
                                                className='col-sm-3 sale'
                                                ref={ref => (inputrefs.current['txtIMEIPhoto'] = ref)}  >
                                                <label className="form-label">IMEI Image <span className='text-danger'>*</span> <PopupWithIcon InfoDetails="Please Dail *#06# on mobile and take a photo with device IMEI No and attach upload" /></label>
                                                <FileUploader
                                                    classes="upload-section file-uploader"
                                                    label="Upload Document"
                                                    handleChange={async (file) => {
                                                        let extArr = (file.name).split(".");
                                                        if (file) {
                                                            try {
                                                                if (file.size < 2 * 1024 * 1024) {
                                                                    if (file.size > 200 * 1024) {
                                                                        if (extArr[1].toUpperCase() === "JPG" || extArr[1].toUpperCase() === "PNG") {
                                                                            const options = {
                                                                                maxSizeMB: 0.2,
                                                                                useWebWorker: true,
                                                                            };
                                                                            await dispatch(setSubLoading(true));
                                                                            const compressedFile = await imageCompression(file, options);
                                                                            await dispatch(setSubLoading(false));
                                                                            file = compressedFile;
                                                                        } else {
                                                                            alert(`File type ${extArr[1].toUpperCase()} compression is not supported. Please upload a smaller file.`);
                                                                            return;
                                                                        }
                                                                    }
                                                                    const reader = new FileReader();
                                                                    reader.readAsDataURL(file);
                                                                    reader.onload = () => {
                                                                        let logo = (reader.result).split(",")[1];
                                                                        setFormData({
                                                                            ...formData,
                                                                            imeiImage: logo,
                                                                            imeiExt: extArr[1],
                                                                            imeiName: extArr[0],
                                                                        });
                                                                    };
                                                                } else {
                                                                    NotificationSound('ERROR', 'Please upload maximum 2 mb image .!')
                                                                }
                                                            } catch (error) {
                                                                console.error("File handling error:", error);
                                                                alert("An error occurred while processing the file. Please try again.");
                                                            }
                                                        }
                                                    }}
                                                    name="file"
                                                    types={["JPG", "PNG"]}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter" || e.key === "Tab") {
                                                            e.preventDefault();
                                                            inputrefs.current["txtInvoiceNo"].focus();
                                                        }
                                                    }}
                                                    children={
                                                        <FileUploadChild
                                                            label=""
                                                            message={`${formData.imeiName}.${formData.imeiExt}`}
                                                            types={["JPG", "PNG"]}
                                                        />
                                                    }
                                                />

                                                {formData.imeiImage ?
                                                    <i className="fa fa-image me-2"
                                                        title='show Image'
                                                        onClick={() => { OpenImage(formData.imeiImage, formData.imeiExt) }}
                                                        style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '14px' }}
                                                    /> : <span className='text-danger' style={{ fontSize: '12px' }}>maximum size : 2MB</span>
                                                }
                                            </div>
                                        </>
                                    }
                                </div>
                                <div className='row mx-0 mb-2 py-1' style={{ borderTop: '2px solid #865fc5', boxShadow: 'rgb(254 170 170 / 28%) 2px 2px 9px' }}>
                                    <div className=''>
                                        <h6 className='mb-2'>Invoice Details</h6>
                                    </div>
                                    <InputBox
                                        id="txtInvoiceNo"
                                        placeholder="Invoice No"
                                        label='Invoice No'
                                        required={true}
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        maxLength='20'
                                        value={formData.invoiceNo}
                                        onChange={(e) => setFormData({ ...formData, invoiceNo: convertToAlphaNum(e.target.value) })}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtInvoiceValue'].focus()
                                            }
                                        }}
                                    />

                                    <InputGroupBox
                                        required={true}
                                        label='Total Invoice Value'
                                        disabled={formData.paid}
                                        handleStartButtonClick={() => ''}
                                        id="txtInvoiceValue"
                                        placeholder="Total Invoice value"
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2 "
                                        maxLength="9"
                                        value={formData.totalInvoiceValue}
                                        onChange={(e) => setFormData({
                                            ...formData,
                                            totalInvoiceValue: convertTwoDecimalsOnValue(e.target.value),
                                            sumInsured: convertTwoDecimalsOnValue(e.target.value)
                                        })}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtInvoiceDate'].focus()
                                            }
                                        }}
                                        startIcon="fa fa-inr"
                                    />
                                    <DateBox
                                        id='txtInvoiceDate'
                                        inputrefs={inputrefs}
                                        label='Invoice Date'
                                        required={true}
                                        minDate={new Date().setDate(new Date().getDate() - Number(InvoiceNoofDays))}
                                        maxDate={new Date()}
                                        placeholder='Invoice Date'
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        selected={formData.invoiceDate === '' ? '' : new Date(formData.invoiceDate)}
                                        onChange={async (e) => {
                                            await handleDateChange(e, setFormData, formData, 'invoiceDate')
                                            await setFormData((pre) => ({ ...pre, activationDate: '' }))
                                        }
                                        }
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') { inputrefs.current['txtActivationDate'].focus() };
                                        }}
                                    />
                                    {
                                        tabData?.filter(item => item.tabKey === (formData.type === 'PHONESAFE' ? 'PHONESAFE' : 'ASSET')).map((item, index) => (
                                            //  Asset
                                            item.tabName === 'Phone' && <DateBox
                                                id='txtActivationDate'
                                                inputrefs={inputrefs}
                                                label='Activation Date'
                                                required={true}
                                                minDate={new Date(formData.invoiceDate)}
                                                maxDate={new Date()}
                                                placeholder='Activation Date'
                                                divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                                selected={formData.activationDate === '' ? '' : new Date(formData.activationDate)}
                                                onChange={(e) => handleDateChange(e, setFormData, formData, 'activationDate')}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { inputrefs.current['txtTitle'].focus() };
                                                }}
                                            />
                                           
                                        ))
                                    }

                               {/*{     !checkAsset && <DateBox*/}
                               {/*         id='txtActivationDate'*/}
                               {/*         inputrefs={inputrefs}*/}
                               {/*         label='Activation Date'*/}
                               {/*         required={true}*/}
                               {/*         minDate={new Date(formData.invoiceDate)}*/}
                               {/*         maxDate={new Date()}*/}
                               {/*         placeholder='Activation Date'*/}
                               {/*         divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"*/}
                               {/*         selected={formData.activationDate === '' ? '' : new Date(formData.activationDate)}*/}
                               {/*         onChange={(e) => handleDateChange(e, setFormData, formData, 'activationDate')}*/}
                               {/*         onKeyDown={(e) => {*/}
                               {/*             if (e.key === 'Enter') { inputrefs.current['txtTitle'].focus() };*/}
                               {/*         }}*/}
                               {/*     />}*/}

                                    <InputGroupBox
                                        required={true}
                                        label='Sum Insured'
                                        handleStartButtonClick={() => ''}
                                        id="txtSumInsured"
                                        placeholder="Sum Insured"
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2 d-none"
                                        maxLength="9"
                                        value={formData.sumInsured}
                                        onChange={(e) => setFormData({ ...formData, sumInsured: convertTwoDecimalsOnValue(e.target.value) })}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtTitle'].focus()
                                            }
                                        }}
                                        startIcon="fa fa-inr"
                                    />
                                    <div
                                        className='col-sm-3 sale'
                                        ref={ref => (inputrefs.current['txtInvoicePhoto'] = ref)}  >
                                        <label className="form-label">Invoice Scanned Copy <span className='text-danger'>*</span></label>
                                        <FileUploader
                                            classes="upload-section file-uploader"
                                            label="Upload Document"
                                            handleChange={async (file) => {
                                                let extArr = file.name.split(".");
                                                let fileExtension = extArr[extArr.length - 1].toUpperCase();

                                                if (file) {
                                                    try {
                                                        if (file.size < 2 * 1024 * 1024) {
                                                            if (file.size > 200 * 1024) {
                                                                if (fileExtension === "JPG" || fileExtension === "PNG") {
                                                                    const imageOptions = {
                                                                        maxSizeMB: 0.2,
                                                                        maxWidthOrHeight: 1920,
                                                                        useWebWorker: true,
                                                                    };
                                                                    file = await imageCompression(file, imageOptions);
                                                                } else if (fileExtension === "PDF") {
                                                                    const pdfBytes = await file.arrayBuffer();
                                                                    const pdfDoc = await PDFDocument.load(pdfBytes);
                                                                    const compressedPdfBytes = await pdfDoc.save({
                                                                        useObjectStreams: true,
                                                                    });
                                                                    file = new File([compressedPdfBytes], file.name, {
                                                                        type: "application/pdf",
                                                                    });
                                                                } else {
                                                                    NotificationSound("ERROR", "Unsupported file type for compression.");
                                                                    return;
                                                                }
                                                            }
                                                            const reader = new FileReader();
                                                            reader.readAsDataURL(file);
                                                            reader.onload = () => {
                                                                let logo = reader.result.split(",")[1];
                                                                setFormData({
                                                                    ...formData,
                                                                    invoiceImage: logo,
                                                                    invoiceExt: extArr[extArr.length - 1],
                                                                    invoiceName: extArr[0],
                                                                });
                                                            };
                                                        } else {
                                                            NotificationSound('ERROR', 'Please upload maximum 2 mb image .!')
                                                        }
                                                    } catch (error) {
                                                        console.error("File compression error:", error);
                                                        NotificationSound("ERROR", "Failed to compress the file. Please try again.");
                                                    }
                                                }
                                            }}
                                            name="file"
                                            types={["JPG", "PNG", "PDF"]}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter" || e.key === "Tab") {
                                                    e.preventDefault();
                                                    inputrefs.current["txtTitle"].focus();
                                                }
                                            }}
                                            children={
                                                <FileUploadChild
                                                    label=""
                                                    message={`${formData.invoiceName}.${formData.invoiceExt}`}
                                                    types={["JPG", "PNG", "PDF"]}
                                                />
                                            }
                                        />
                                        <span className='text-danger' style={{ fontSize: '12px' }}>maximum size : 2MB</span>
                                    </div>
                                    {formData.invoiceImage &&
                                        <div className='col-sm-3 pt-4'>
                                            {(formData.invoiceExt).toLowerCase() === 'pdf' ?
                                                <FaFilePdf title='open PDF'
                                                    style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '16px' }}
                                                    onClick={() => { OpenImage(formData.invoiceImage, formData.invoiceExt) }}
                                                /> :
                                                <i className="fa fa-image me-2"
                                                    title='show Image'
                                                    onClick={() => { OpenImage(formData.invoiceImage, formData.invoiceExt) }}
                                                    style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '14px' }}
                                                />
                                            }
                                        </div>
                                    }


                                    <InputBox
                                        id="txtEmployeeID"
                                        placeholder="Employee ID"
                                        label='Employee ID'
                                        required={true}
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        maxLength='50'
                                        value={formData.employeeID}
                                        onChange={(e) => setFormData({ ...formData, employeeID: sanitizeInput(e.target.value) })}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtTitle'].focus()
                                            }
                                        }}
                                    />

                                </div>
                                <div className='row mx-0 customer mb-2 py-1' style={{ borderTop: '2px solid green', boxShadow: 'rgb(254 170 170 / 28%) 2px 2px 9px' }}>
                                    <div className=''>
                                        <h6 className='mb-2'>Customer Details</h6>
                                    </div>
                                    <SelectInputBox
                                        id="txtTitle"
                                        label='Title'
                                        value={formData.title}
                                        required={true}
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtFirstName'].focus()
                                            }
                                        }}
                                    >
                                        <option value=''>--Please Select--</option>
                                        <option value='MR'>MR</option>
                                        <option value='MRS'>MRS</option>
                                        <option value='MISS'>MISS</option>
                                        <option value='Other'>Other</option>
                                    </SelectInputBox>
                                    <InputBox
                                        id="txtFirstName"
                                        label='First Name'
                                        required={true}
                                        placeholder="First Name"
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        maxLength='50'
                                        value={formData.firstName}
                                        onChange={(e) => setFormData({ ...formData, firstName: convertToAlphabet(e.target.value) })}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtLastName'].focus()
                                            }
                                        }}
                                    />
                                    <InputBox
                                        id="txtLastName"
                                        label='Last Name'
                                        placeholder="Last Name"
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        maxLength='50'
                                        required
                                        value={formData.lastName}
                                        onChange={(e) => setFormData({ ...formData, lastName: convertToAlphabet(e.target.value) })}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtGender'].focus()
                                            }
                                        }}
                                    />
                                    <SelectInputBox
                                        id="txtGender"
                                        value={formData.gender}
                                        label='Gender'
                                        onChange={(e) => setFormData({ ...formData, gender: e.target.value })}
                                        inputrefs={inputrefs}
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtTelephoneNumber'].focus()
                                                inputrefs.current['txtTelephoneNumber'].focus()
                                            }
                                        }}
                                    >
                                        <option value=''>--Please Select--</option>
                                        <option value='Male'>Male</option>
                                        <option value='Female'>Female</option>
                                        <option value='Other'>Other</option>
                                    </SelectInputBox>
                                    <InputBox
                                        id="txtTelephoneNumber"
                                        label='Telephone Number'
                                        placeholder="Telephone Number"
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        maxLength='15'
                                        value={formData.telephoneNumber}
                                        onChange={(e) => setFormData({ ...formData, telephoneNumber: convertToNumber(e.target.value) })}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtEmailAddress'].focus()
                                            }
                                        }}
                                    />
                                    <InputBox
                                        id="txtEmailAddress"
                                        label='Email Address'
                                        placeholder="Email Address"
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        maxLength='50'
                                        required={true}
                                        value={formData.emailAddress}
                                        onChange={(e) => setFormData({ ...formData, emailAddress: sanitizeInput(e.target.value) })}
                                        inputrefs={inputrefs}
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter') {
                                                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                                                if (!emailRegex.test(formData.emailAddress)) {
                                                    setTimeout(() => {
                                                        NotificationSound('ERROR', "Please enter a valid Email Id.", '')
                                                    }, 0)
                                                    inputrefs.current['txtEmailAddress'].focus()
                                                }
                                                else {
                                                    inputrefs.current['txtMobilePhoneNumber'].focus()
                                                }
                                            }
                                        }}
                                    />
                                    <InputBox
                                        id="txtMobilePhoneNumber"
                                        label='Mobile Number'
                                        required={true}
                                        placeholder="Mobile Number"
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        maxLength='10'
                                        value={formData.mobilePhoneNumber}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value.length > 0 && value[0] === '0') {
                                                return;
                                            }
                                            setFormData({
                                                ...formData,
                                                mobilePhoneNumber: convertToNumber(value)
                                            });
                                        }}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtBillingPostcode'].focus()
                                            }
                                        }}
                                    />

                                    <AutoCompleteBoxNumeric
                                        id="txtBillingPostcode"
                                        label='Billing Postcode'
                                        required={true}
                                        placeholder="Billing Postcode"
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        maxLength='6'
                                        value={formData.billingPostcode || ''}
                                        onChange={async (event, newInputValue) => {
                                            newInputValue = newInputValue || '';
                                            const value = newInputValue;
                                            if (value.length > 0 && value[0] === '0') {
                                                return;
                                            }
                                            if (event.type !== 'keydown') {
                                                let GetBillingTown = await FetchAutoCompleteData('', '.', 'GetBillingTown', value);
                                                let GetBillingState = await FetchAutoCompleteData('', '.', 'GetBillingState', value);
                                                setFormData({
                                                    ...formData,
                                                    billingPostcode: convertToNumber(value),
                                                    billingTown: GetBillingTown.length > 0 ? GetBillingTown[0] : '',
                                                    billingState: GetBillingState.length > 0 ? GetBillingState[0] : ''
                                                });

                                            }
                                        }}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtBillingTown'].focus()
                                            }
                                        }}
                                        onfocusevent={true}
                                        autocompleteType='GetPinCodeData'
                                    />
                                    <AutoCompleteBoxNew
                                        id="txtBillingTown"
                                        label='Billing Town'
                                        required={true}
                                        placeholder="Billing Town"
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-2"
                                        maxLength='30'
                                        value={formData.billingTown || ''}
                                        onChange={(event, newInputValue) => {
                                            newInputValue = newInputValue || ''
                                            if (event.type !== 'keydown') {
                                                setFormData({ ...formData, billingTown: newInputValue })
                                            }
                                        }}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtBillingState'].focus()
                                            }
                                        }}
                                        onfocusevent={true}
                                        autocompleteType='GetBillingTown'
                                        contextKey={formData?.billingPostcode}
                                    />
                                    <AutoCompleteBoxNew
                                        id="txtBillingState"
                                        label='Billing State'
                                        required={true}
                                        placeholder="Billing State"
                                        divclassname="col-lg-3 col-md-3 col-sm-12 mb-1"
                                        maxLength='30'
                                        value={formData.billingState || ''}
                                        onChange={(event, newInputValue) => {
                                            newInputValue = newInputValue || ''
                                            if (event.type !== 'keydown') {
                                                setFormData({ ...formData, billingState: newInputValue })
                                            }
                                        }}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault()
                                                inputrefs.current['txtBillingAddressLine1'].focus()
                                            }
                                        }}

                                        onfocusevent={true}
                                        autocompleteType='GetBillingState'
                                        contextKey={formData?.billingPostcode}
                                    />

                                    <div className='row'>
                                        <div className="col-lg-4 col-md-4 col-sm-12">
                                            <label style={{ 'whiteSpace': 'nowrap' }} className="form-label" >Billing Address Line 1<span style={{ color: "red" }}> *</span></label>
                                            <textarea
                                                id="txtBillingAddressLine1"
                                                maxLength={50}
                                                ref={ref => (inputrefs.current["txtBillingAddressLine1"] = ref)}
                                                className="col-lg-6 col-md-6 col-sm-12 form-control"
                                                placeholder="Billing Address Line 1"
                                                cols={500}
                                                value={formData.billingAddressLine1}
                                                onChange={(e) => setFormData({ ...formData, billingAddressLine1: sanitizeInput(e.target.value) })}
                                            />
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-12">
                                            <label style={{ 'whiteSpace': 'nowrap' }} className="form-label" >Billing Address Line 2</label>
                                            <textarea
                                                id="txtBillingAddressLine2"
                                                maxLength={50}
                                                ref={ref => (inputrefs.current["txtBillingAddressLine2"] = ref)}
                                                className="col-lg-6 col-md-6 col-sm-12 form-control"
                                                placeholder="Billing Address Line 2"
                                                cols={500}
                                                value={formData.billingAddressLine2}
                                                onChange={(e) => setFormData({ ...formData, billingAddressLine2: sanitizeInput(e.target.value) })}
                                            />
                                        </div>

                                        <div className="col-lg-4 col-md-4 col-sm-12">
                                            <label style={{ 'whiteSpace': 'nowrap' }} className="form-label" >Billing Address Line 3</label>
                                            <textarea
                                                id="txtBillingAddressLine3"
                                                maxLength={50 }
                                                ref={ref => (inputrefs.current["txtBillingAddressLine3"] = ref)}
                                                className="col-lg-6 col-md-6 col-sm-12 form-control"
                                                placeholder="Billing Address Line 3"
                                                cols={500}
                                                value={formData.billingAddressLine3}
                                                onChange={(e) => setFormData({ ...formData, billingAddressLine3: sanitizeInput(e.target.value) })}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-3 p-1'>
                                <div className='row mx-0 mb-2 py-1' style={{
                                    border: '1px solid #ddd',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    backgroundColor: 'var(--background)',
                                    overflow: 'hidden',
                                    borderTop: '2px solid #004196'
                                }}>
                                    <div className='col'>
                                        <h6 className='mb-3 pb-1' style={{ borderBottom: '2px solid #004196' }}>
                                            Membership Amount Details
                                        </h6>
                                        {isLoading ? (
                                            <div className='d-flex justify-content-center align-items-center' style={{ height: '100px' }}>
                                                <ColorRing
                                                    visible={true}
                                                    height="80"
                                                    width="80"
                                                    ariaLabel="blocks-loading"
                                                    wrapperStyle={{}}
                                                    wrapperClass="blocks-wrapper"
                                                    colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                                                />
                                            </div>
                                        ) : (
                                            showAmount && (
                                                <div className='col mt-3' style={{
                                                    border: '1px solid #4CAF50',
                                                    backgroundColor: 'var(--background)',
                                                    borderRadius: '5px',
                                                    padding: '10px',
                                                    textAlign: 'center',
                                                }}>
                                                    <div className="d-flex justify-content-between align-items-center mb-2 payment_desc">
                                                        <h6 style={{ margin: '0', }}>Product Name:</h6>
                                                        <h6 style={{ margin: '0', fontWeight: 'bold', color: 'red', }}>
                                                            {(formData?.productCode)}
                                                        </h6>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center mb-2 payment_desc">
                                                        <h6 style={{ margin: '0', }}>Category Name:</h6>
                                                        <h6 style={{ margin: '0', fontWeight: 'normal' }}>
                                                            {amountDetailsData.assestProductName}
                                                        </h6>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center mb-2 payment_desc">
                                                        <h6 style={{ margin: '0', }}>{formData.type === 'PHONESAFE' ? "Membership Period" : "Exended Warranty"} :</h6>
                                                            <h6 style={{ margin: '0', fontWeight: 'normal', }}>
                                                                {formData.noOfYears}(Years)
                                                        </h6>
                                                    </div>
                                                    {formData.invoiceNo !== '' &&
                                                        <div className="d-flex justify-content-between align-items-center mb-2 payment_desc">
                                                            <h6 style={{ margin: '0', }}>Invoice Number :</h6>
                                                            <h6 style={{ margin: '0', fontWeight: 'normal', fontSize: '12px' }}>
                                                                {formData.invoiceNo}
                                                            </h6>
                                                        </div>
                                                    }
                                                    {formData.invoiceDate !== '' &&
                                                        <div className="d-flex justify-content-between align-items-center mb-2 payment_desc">
                                                            <h6 style={{ margin: '0', }}>Invoice Date :</h6>
                                                            <h6 style={{ margin: '0', fontWeight: 'normal', fontSize: '12px' }}>
                                                                {formData.invoiceDate}
                                                            </h6>
                                                        </div>
                                                    }
                                                    {formData.totalInvoiceValue !== '' &&
                                                        <div className="d-flex justify-content-between align-items-center mb-2 payment_desc">
                                                            <h6 style={{ margin: '0', }}>Invoice Amount :</h6>
                                                            <h6 style={{ margin: '0', fontWeight: 'bold', fontSize: '12px' }}>
                                                                {formData.totalInvoiceValue}
                                                            </h6>
                                                        </div>
                                                    }
                                                    <div className="d-flex justify-content-between align-items-center payment_desc">
                                                        <h6 style={{ margin: '0', }}>Membership Amount:</h6>
                                                        <span style={{ color: 'green', fontWeight: 'bold' }}>
                                                            ₹ {parseInt(amountDetailsData.cost, 10)}
                                                        </span>
                                                    </div>
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='card-body pb-1 d-flex algin-items-center justify-content-center'>
                            <button type="button" name={'Next'}
                                onClick={handleNext}
                                className="btn btn-rounded btn-primary">
                                <span className="text-white">
                                    Validate & Next <i className="fa-solid ms-1 fa-forward color-primary" />
                                </span>
                            </button>
                            <FormButton
                                id={'btnSub'}
                                inputrefs={inputrefs}
                                Export={false}
                                save={false}
                                handleClear={() => {
                                    Swal.fire({
                                        title: "Are you sure?",
                                        text: "want to Reset this form?",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "#3085d6",
                                        cancelButtonColor: "#d33",
                                        confirmButtonText: "Yes",
                                        keydownListenerCapture: true,
                                        stopKeydownPropagation: false,
                                        didOpen: () => {
                                            document.addEventListener('keydown', function (event) {
                                                if (event.key === 'Y' || event.key === 'y') {
                                                    Swal.clickConfirm();
                                                } else if (event.key === 'N' || event.key === 'n') {
                                                    Swal.clickCancel();
                                                }
                                            });
                                        }
                                    }).then(async (result) => {
                                        if (result.isConfirmed) {
                                            handleClear()
                                        }
                                    });
                                }}
                            />
                        </div>
                    </>
                    :
                    ProgressStage === 'CONFIRM' ?
                        <>
                            <div className='card-header confirm_process'>
                                <div className='container-fluid px-0'>
                                    <div className='row'>
                                        <div className='col-md-9 pe-md-1'>
                                            <div className='row'>
                                                <div className='col-md-4 col-sm-6 mb-2 pe-md-1'>
                                                    <div className='card' style={{ borderTop: '2px solid #865fc5', boxShadow: 'rgb(254 170 170 / 28%) 2px 2px 9px', height: "100%" }}>
                                                        <div className='card-body p-2 py-0'>
                                                            <h6 className='my-1 pb-1' style={{ borderBottom: '1px solid #865fc5', color: '#865fc5' }}>Invoice Details</h6>
                                                            <div className='table-responsive'>
                                                                <table className='table-bordered table'>
                                                                    <tbody>
                                                                        <tr>
                                                                            <th>Invoice No</th>
                                                                            <td className='fw-bold text-primary'>{formData.invoiceNo}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Invoice Date</th>
                                                                            <td>{formData.invoiceDate}</td>
                                                                        </tr>
                                                                        {checkAsset &&
                                                                        <tr>
                                                                            <th>Activation Date</th>
                                                                            <td>{formData.activationDate}</td>
                                                                        </tr>
                                                                        }
                                                                        <tr>
                                                                            <th>Invoice Value</th>
                                                                            <td>₹ {formData.totalInvoiceValue}  {formData.invoiceImage &&(
                                                                                 (formData.invoiceExt).toLowerCase() === 'pdf' ?
                                                                                        <FaFilePdf title='open PDF'
                                                                                            style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '16px' }}
                                                                                            onClick={() => { OpenImage(formData.invoiceImage, formData.invoiceExt) }}
                                                                                        /> :
                                                                                        <i className="fa fa-image me-2"
                                                                                            title='show Image'
                                                                                            onClick={() => { OpenImage(formData.invoiceImage, formData.invoiceExt) }}
                                                                                            style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '14px' }}
                                                                                        />
                                                                            ) }</td>
                                                                        </tr>
                                                                        <tr className="d-none">
                                                                            <th>Sum Insured</th>
                                                                            <td>₹ {formData.sumInsured}</td>
                                                                        </tr>
                                                                        {/*{formData.invoiceImage &&*/}
                                                                        {/*    <tr >*/}
                                                                        {/*        <th>Invoice Copy</th>*/}
                                                                        {/*        <td>  {(formData.invoiceExt).toLowerCase() === 'pdf' ?*/}
                                                                        {/*            <FaFilePdf title='open PDF'*/}
                                                                        {/*                style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '16px' }}*/}
                                                                        {/*                onClick={() => { OpenImage(formData.invoiceImage, formData.invoiceExt) }}*/}
                                                                        {/*            /> :*/}
                                                                        {/*            <i className="fa fa-image me-2"*/}
                                                                        {/*                title='show Image'*/}
                                                                        {/*                onClick={() => { OpenImage(formData.invoiceImage, formData.invoiceExt) }}*/}
                                                                        {/*                style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '14px' }}*/}
                                                                        {/*            />*/}
                                                                        {/*        }</td>*/}
                                                                        {/*    </tr>}*/}
                                                                        <tr>
                                                                            <th>Employee ID</th>
                                                                            <td>{formData.employeeID}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-md-8 col-sm-6 mb-2 ps-md-1'>
                                                    <div className='card' style={{ borderTop: '2px solid #ff0000', boxShadow: 'rgb(254 170 170 / 28%) 2px 2px 9px' }}>
                                                        <div className='card-body p-2 py-0'>
                                                            <h6 className='my-1 pb-1' style={{ borderBottom: '1px solid #ff0000', color: '#ff0000' }}>Product Details</h6>
                                                            <div className='table-responsive'>
                                                                <table className='table-bordered table'>
                                                                    <tbody>
                                                                        <tr>
                                                                            <th>Product</th>
                                                                            <td className='fw-bold text-danger'>{formData.productCode}</td>
                                                                            <th>Category</th>
                                                                            <td> {formData.categoryName && formData.categoryName.trim() !== ''
                                                                                ? `${formData.categoryName}`
                                                                                : `${formData.category}`}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Manufacturer</th>
                                                                            <td >
                                                                                {formData.manufacturerName && formData.manufacturerName.trim() !== ''
                                                                                    ? `${formData.manufacturerName}`
                                                                                    : `${formData.manufacturer}`}
                                                                            </td>
                                                                            {formData.manufacturerModelNo && (
                                                                                <>
                                                                                    <th>Manufacturer Model No</th>
                                                                                    <td>{formData.manufacturerModelNo}</td>
                                                                                </>
                                                                            )}
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Serial No</th>
                                                                            <td>{formData.serialNo}</td>
                                                                            <th>Extended Warranty</th>
                                                                            <td>{formData.noOfYears} (Year's)</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Model No</th>
                                                                            <td>{formData.modelNo}</td>
                                                                            <th>Purchase Date</th>
                                                                            <td>{formData.purchaseDate}</td>
                                                                        </tr>

                                                                        {formData.otherModelNo && !formData.otherManufacturer && (
                                                                            <tr>
                                                                                <th>Other Model No</th>
                                                                                <td>{formData.otherModelNo}</td>
                                                                            </tr>
                                                                        )}
                                                                        {formData.otherManufacturer && !formData.otherModelNo && (
                                                                            <tr>
                                                                                <th>Other Manufacturer</th>
                                                                                <td>{formData.otherManufacturer}</td>
                                                                            </tr>
                                                                        )}
                                                                        {formData.otherModelNo && formData.otherManufacturer && (
                                                                            <tr>
                                                                                <th>Other Model No</th>
                                                                                <td>{formData.otherModelNo}</td>
                                                                                <th>Other Manufacturer</th>
                                                                                <td>{formData.otherManufacturer}</td>
                                                                            </tr>
                                                                        )}
                                                                        {formData.imei && (
                                                                            <tr>
                                                                                <th>IMEI</th>
                                                                                <td >{formData.imei}</td>
                                                                                <th>IMEI Image</th>
                                                                                <td ><i className="fa fa-image me-2"
                                                                                    title='show Image'
                                                                                    onClick={() => { OpenImage(formData.imeiImage, formData.imeiExt) }}
                                                                                    style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '14px' }}
                                                                                /></td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card' style={{ borderTop: '2px solid #008000', boxShadow: 'rgb(254 170 170 / 28%) 2px 2px 9px' }}>
                                                <div className='card-body p-2 py-0'>
                                                    <h6 className='my-1 pb-1' style={{ borderBottom: '1px solid #008000', color: '#008000' }}>Customer Details</h6>
                                                    <div className='table-responsive'>
                                                        <table className='table-bordered table'>
                                                            <tbody>
                                                                <tr>
                                                                    <th>Title</th>
                                                                    <td>{formData.title}</td>
                                                                    <th>First Name</th>
                                                                    <td>{formData.firstName}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Last Name</th>
                                                                    <td>{formData.lastName}</td>
                                                                    <th>Gender</th>
                                                                    <td>{formData.gender}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Tel. Number</th>
                                                                    <td>{formData.telephoneNumber}</td>
                                                                    <th>Email Address</th>
                                                                    <td>{formData.emailAddress}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Mobile No.</th>
                                                                    <td>{formData.mobilePhoneNumber}</td>
                                                                    <th>Billing Postcode</th>
                                                                    <td>{formData.billingPostcode}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Billing Town</th>
                                                                    <td>{formData.billingTown}</td>
                                                                    <th>Billing State</th>
                                                                    <td>{formData.billingState}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Billing Address Line 1</th>
                                                                    <td>{formData.billingAddressLine1}</td>
                                                                    <th>Billing Address Line 2</th>
                                                                    <td>{formData.billingAddressLine2}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Billing Address Line 3</th>
                                                                    <td >{formData.billingAddressLine3}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-3 col-sm-12 ps-md-1 sale-selectionType d-flex flex-column'>
                                            <div
                                                className='card flex-grow-1'
                                                style={{ borderTop: '2px solid orange', boxShadow: 'rgb(254 170 170 / 28%) 2px 2px 9px' }}>
                                                <div className='card-body p-2 pt-0'>
                                                    <h6
                                                        className='my-1 pb-1'
                                                        style={{ borderBottom: '1px solid orange', color: 'orange' }}
                                                    >
                                                        Amount Details
                                                    </h6>
                                                    {showAmount ? (
                                                        <div className='col mt-3 payment_desc' style={{
                                                            border: '1px solid #4CAF50',
                                                            backgroundColor: 'var(--background)',
                                                            borderRadius: '5px',
                                                            padding: '10px',
                                                            textAlign: 'center',
                                                        }}>
                                                            <div className="d-flex justify-content-between align-items-center mb-2 payment_desc">
                                                                <h6 style={{ margin: '0', }}>Product Name:</h6>
                                                                <h6 style={{ margin: '0', fontWeight: 'bold', color: 'red', }}>
                                                                    {(formData?.productCode)}
                                                                </h6>
                                                            </div>
                                                            <div className="d-flex justify-content-between align-items-center mb-2 payment_desc">
                                                                <h6 style={{ margin: '0', }}>Category Name:</h6>
                                                                <h6 style={{ margin: '0', fontWeight: 'normal', }}>
                                                                    {amountDetailsData.assestProductName}
                                                                </h6>
                                                            </div>
                                                            <div className="d-flex justify-content-between align-items-center mb-2 payment_desc">
                                                                <h6 style={{ margin: '0', }}>{formData.type === 'PHONESAFE' ? "Membership Period" : "Exended Warranty"} :</h6>
                                                                <h6 style={{ margin: '0', fontWeight: 'normal', }}>
                                                                    {formData.noOfYears}(Years)
                                                                </h6>
                                                            </div>
                                                            {formData.invoiceNo !== '' &&
                                                                <div className="d-flex justify-content-between align-items-center mb-2 payment_desc">
                                                                    <h6 style={{ margin: '0', }}>Invoice Number :</h6>
                                                                    <h6 style={{ margin: '0', fontWeight: 'normal', fontSize: '12px' }}>
                                                                        {formData.invoiceNo}
                                                                    </h6>
                                                                </div>
                                                            }
                                                            {formData.invoiceDate !== '' &&
                                                                <div className="d-flex justify-content-between align-items-center mb-2 payment_desc">
                                                                    <h6 style={{ margin: '0', }}>Invoice Date :</h6>
                                                                    <h6 style={{ margin: '0', fontWeight: 'normal', fontSize: '12px' }}>
                                                                        {formData.invoiceDate}
                                                                    </h6>
                                                                </div>
                                                            }
                                                            {formData.totalInvoiceValue !== '' &&
                                                                <div className="d-flex justify-content-between align-items-center mb-2 payment_desc">
                                                                    <h6 style={{ margin: '0', }}>Invoice Amount :</h6>
                                                                    <h6 style={{ margin: '0', fontWeight: 'bold', fontSize: '12px' }}>
                                                                        {formData.totalInvoiceValue}
                                                                    </h6>
                                                                </div>
                                                            }
                                                            <div className="d-flex justify-content-between align-items-center payment_desc">
                                                                <h6 style={{ margin: '0', }}>Membership Amount:</h6>
                                                                <span style={{ color: 'green', fontWeight: 'bold' }}>
                                                                    ₹ {parseInt(amountDetailsData.cost, 10)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className=" mt-2">
                                                <div className="card p-2" style={{ borderTop: '2px solid orange', boxShadow: 'rgb(254 170 170 / 28%) 2px 2px 9px' }}>
                                                    {formData.paid ? <h6
                                                        className='mb-1 pb-1'
                                                        style={{ borderBottom: '2px solid orange', color: 'green' }}
                                                    >
                                                        Payment has been successfully completed for this sale.
                                                    </h6> : <><h6
                                                        className='mb-1 pb-1'
                                                        style={{ borderBottom: '1px solid orange', color: 'green' }}
                                                    >
                                                        Payment Selection
                                                    </h6>
                                                        <div className="select_pay_mode">
                                                            <label className={`label_box mb-3 border-0`} htmlFor="cardmode">
                                                                <input type="checkbox"
                                                                    name='paymode'
                                                                    hidden
                                                                    id='cardmode'
                                                                    disabled={formData.paid}
                                                                    value='CUSTOMERPAYMENT'
                                                                    onChange={(e) => setFormData({ ...formData, selectionType: e.target.checked ? 'CUSTOMERPAYMENT' : 'PAYLATER' })}
                                                                    checked={formData.selectionType === "CUSTOMERPAYMENT" ? true : false}
                                                                />
                                                                <div style={{ cursor: formData.paid ? 'no-drop' : 'pointer' }} className="d-flex justify-content-between align-items-center gap-2 w-100 adrss_body position-relative">
                                                                    <div>
                                                                        <div className="circle_radio">
                                                                        </div>
                                                                        <p className='m-0'>Pay By Customer</p>
                                                                    </div>
                                                                    <div className='d-flex align-items-center gap-2' style={{ filter: formData.selectionType === 'CUSTOMERPAYMENT' ? 'inherit' : 'grayScale(1)', opacity: formData.selectionType === 'CUSTOMERPAYMENT' ? '1' : '0.8' }}>
                                                                        <img src="./images/payment.svg" width='25' alt="" />
                                                                    </div>
                                                                </div>
                                                            </label>
                                                            {!amountDetailsData.isCustomerPayment &&
                                                                <label className='label_box mb-3 border-0' htmlFor="cod">
                                                                    <input
                                                                        type="checkbox"
                                                                        name='paymode'
                                                                        hidden
                                                                        id='cod'
                                                                        disabled={formData.paid}

                                                                        value='DEALERPAYMENT'
                                                                        onChange={(e) => setFormData({ ...formData, selectionType: e.target.checked ? 'DEALERPAYMENT' : 'PAYLATER' })}
                                                                        checked={formData.selectionType === "DEALERPAYMENT" ? true : false}
                                                                    />
                                                                    <div style={{ cursor: formData.paid ? 'no-drop' : 'pointer' }} className="d-flex justify-content-between align-items-center gap-2 w-100 adrss_body position-relative">
                                                                        <div>
                                                                            <div className="circle_radio"></div>
                                                                            <p className='m-0'>Pay By Dealer</p>
                                                                        </div>
                                                                        <div className='d-flex align-items-center gap-2' style={{ filter: formData.selectionType === 'DEALERPAYMENT' ? 'inherit' : 'grayScale(1)', opacity: formData.selectionType === 'DEALERPAYMENT' ? '1' : '0.8' }}>
                                                                            <img src="./images/payment.svg" width='25' alt="" />
                                                                        </div>
                                                                    </div>
                                                                </label>
                                                            }
                                                        </div></>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='card-body pb-1 pt-2 d-flex algin-items-center justify-content-between'>
                                <button type="button" name={'Prev'}
                                    onClick={handlePrev}
                                    className="btn btn-rounded btn-primary ms-2 p-1">
                                    <span className="text-white">
                                        <i className="fa-solid fa-backward" />   Previous
                                    </span>
                                </button>
                                <div className="terms-condition">
                                    {/*<input*/}
                                    {/*    type="checkbox"*/}
                                    {/*    id="termsCheckbox"*/}
                                    {/*    checked={isChecked}*/}
                                    {/*    onChange={() => setIsChecked(!isChecked)}*/}
                                    {/*/>&nbsp;*/}
                                    {/*<label htmlFor="termsCheckbox">*/}
                                    {/*    I agree to the <a*/}
                                    {/*        href={GetAssetMaster?.data?.pdfurl}*/}
                                    {/*        target="_blank"*/}
                                    {/*        rel='noreferrer'*/}
                                    {/*    ><u>Terms and Conditions</u></a>.*/}
                                    {/*</label>*/}

                                    {formData.selectionType === 'DEALERPAYMENT' ?
                                        <button type="button"
                                            onClick={() => handlePaymentSelection('E')}
                                            className="btn btn-rounded btn-success ms-2 p-1">
                                            <span className="text-white">
                                                <i className="fas fa-credit-card color-success" /> Make Payment
                                            </span>
                                        </button> : formData.selectionType === 'CUSTOMERPAYMENT' ?
                                            <button type="button"
                                                onClick={() => handlePaymentSelection('C')}
                                                className="btn btn-rounded btn-success ms-2 p-1">
                                                <span className="text-white">
                                                    <i className="fa fa-envelope color-success" /> Send Payment Link
                                                </span>
                                            </button> : formData.selectionType === 'PAYLATER' &&
                                                formData.paid ? <button type="button"
                                                   // onClick={() => handleSubmitRef('', formData.onlinePaymentID)}
                                                    className="btn btn-rounded btn-success ms-2 p-1">
                                                <span className="text-white">
                                                    <i className="fa">&#xf0c7;</i> Generate Policy
                                                </span>
                                            </button> :
                                                <button type="button"
                                                    onClick={() => handlePaymentSelection('P')}
                                                    className="btn btn-rounded btn-success ms-2 p-1">
                                                    <span className="text-white">
                                                        <i className="fa">&#xf0c7;</i> Save As Draft
                                                    </span>
                                                </button>
                                    }
                                </div>
                            </div>
                        </>
                        :
                        ProgressStage === 'PAYMENT' ?
                            <div className='card-header'>
                                <div className='container-fluid px-0'>
                                    <div className='row'>
                                        <div className='text-center'>
                                            <img src={PaymentResponse?.status === 'SUCCESS' ? "./images/thank-you.png" : "./images/fail.png"} style={{
                                                width: "140px",
                                                height: "120px",
                                            }} alt="Failure Icon" />
                                        </div>
                                        <h3 className={`text-center px-5 pt-5 fw-bold ${PaymentResponse?.status === 'SUCCESS' ? 'text-success' : "text-danger"}`}>{PaymentResponse?.status}</h3>
                                        <h5 className='pb-2 px-5 text-center'>{PaymentResponse?.errorDesc}</h5>
                                        {PaymentResponse?.status !== 'SUCCESS' &&
                                            <>
                                                <h6 className='px-5 text-center'>It seems there was a problem with your payment. Kindly try again.</h6>
                                                <div className='card-body pb-1 pt-2 d-flex algin-items-center justify-content-center'>
                                                    <button type="button" name={'Prev'}
                                                        onClick={() => handleRetryPayment()}
                                                        className="btn btn-rounded btn-warning ms-2 p-1">
                                                        <span className="text-white">
                                                            <i className="fa-solid fa fa-refresh" />   Retry Payment
                                                        </span>
                                                    </button>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            :
                            ProgressStage === 'FINAL' && <FinalView message={message} handleClear={handleClear} />
                }
                <Dialog
                    open={openPaymentModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{
                        "& .MuiDialog-container": {
                            "& .MuiPaper-root": {
                                width: "100%",
                                maxWidth: "600px",
                            }
                        },
                        "& .css-hz1bth-MuiDialog-container": {
                            alignItems: 'start'
                        }
                    }}
                >
                    <DialogTitle id="alert-dialog-title" className='py-1 px-2 border-bottom d-flex justify-content-between'>
                        <div style={{ fontWeight: 700 }}>Payment Details</div>
                        <div style={{ fontWeight: 500, cursor: 'pointer' }} title='close'><i className='fa-solid fa-xmark'
                            onClick={() => setOpenPaymentModal(false)}
                        /></div>
                    </DialogTitle>
                    <DialogContent className='main-card px-0 mx-0 my-0 py-1' style={{ boxShadow: 'none' }}>
                        <div className='row px-0 mx-1 pb-1 border-bottom'>
                            <div className="py-1 mb-2 px-3 rounded" style={{ boxShadow: 'rgba(101, 155, 242, 0.5) 0px 0px 5px', borderTop: "2px solid #f18282" }} >
                                <div className='col mt-3' style={{
                                    border: '1px solid #4CAF50',
                                    backgroundColor: 'var(--last_bg_all)',
                                    borderRadius: '5px',
                                    padding: '10px',
                                    textAlign: 'center',
                                }}>
                                    <div className="d-flex justify-content-between align-items-center mb-2 payment_desc">
                                        <h6 style={{ margin: '0', fontWeight: "bold" }}>Customer Name:</h6>
                                        <h6 style={{ margin: '0', fontWeight: 'bold', color: 'red' }}>
                                            {formData.title} {formData.firstName} {formData.lastName}
                                        </h6>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-2 payment_desc">
                                        <h6 style={{ margin: '0', fontWeight: "bold" }}>Invoice No:</h6>
                                        <h6 style={{ margin: '0', fontWeight: 'bold', }}>
                                            {formData.invoiceNo}
                                        </h6>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-2 payment_desc">
                                        <h6 style={{ margin: '0', fontWeight: "bold" }}>Membership Name:</h6>
                                        <h6 style={{ margin: '0', fontWeight: 'bold', }}>
                                            {amountDetailsData.assestProductName}
                                        </h6>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-2 payment_desc">
                                        <h6 style={{ margin: '0', fontWeight: "bold" }}>Purchase Date:</h6>
                                        <h6 style={{ margin: '0', fontWeight: 'bold', }}>
                                            {formData.purchaseDate}
                                        </h6>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-2 payment_desc">
                                        <h6 style={{ margin: '0', fontWeight: "bold" }}>Membership Amount:</h6>
                                        <span style={{ color: 'green', fontWeight: 'bold' }}>
                                            ₹ {parseInt(amountDetailsData.cost, 10)}
                                        </span>
                                    </div>
                                    {isDisabled &&
                                        <label className={'text-success fs-6'}>{Response.message}</label>
                                    }
                                    <>
                                        <InputBox
                                            id="txtotp"
                                            labelclass=' fw-bold mb-0'
                                            label={"Enter 6 Digit OTP :"}
                                            divclassname='d-flex align-items-center gap-4 pt-2 px-5'
                                            inputrefs={inputrefs}
                                            value={OTPValue}
                                            maxLength={6}
                                            onChange={(e) => {
                                                setOTPValue(convertToNumber(e.target.value))
                                                setErrorResponse({})
                                            }
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    inputrefs.current['btnSub'].focus()
                                                };
                                            }}
                                        />
                                        {ErrorResponse.message &&
                                            <p className='text-danger'>{ErrorResponse.message}</p>
                                        }
                                        <p style={{ color: 'var(--text)' }} className='mt-3 mb-2 d-flex justify-content-center align-items-center'>
                                            Didn't receive an OTP?
                                            <button
                                                type="button"
                                                onClick={handleSendOtp}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    color: '#007bff',
                                                    fontWeight: 'bold',
                                                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                    marginLeft: '7px',
                                                    opacity: isDisabled ? 0.5 : 1,
                                                }}
                                                disabled={isDisabled}
                                            >
                                                {isDisabled ? `Resend (${timer}s)` : 'Resend'}
                                            </button>
                                        </p>
                                    </>
                                </div>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions className='main-card py-0 pt-1 my-0 px-1' style={{ boxShadow: 'none' }}>
                        <button type="button"
                            onClick={() => handlePayment(formData.headerId)}
                            className="btn btn-rounded ms-1 text-light btn-success" >
                            <span className=" text-white me-2">
                            </span>PAY (₹{parseInt(amountDetailsData.cost, 10)})</button>
                    </DialogActions>
                </Dialog>
            </div >
        </>
    )
}
export default SaleEntry;